import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment, renderList as _renderList, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cebc4671"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-quest-title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "nge-quest-icon" }, "🧠"),
  /*#__PURE__*/_createTextVNode(" Brain Quest ")
], -1 /* HOISTED */))
const _hoisted_2 = { class: "nge-quest-topbar-actions" }
const _hoisted_3 = {
  key: 0,
  class: "nge-quest-setup"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-quest-setup-text" }, " Paste a queue spreadsheet to start your expedition. ", -1 /* HOISTED */))
const _hoisted_5 = ["onKeydown"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "nge-quest-error"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-quest-loading" }, " Scanning neurons… ", -1 /* HOISTED */))
const _hoisted_9 = { class: "nge-quest-content" }
const _hoisted_10 = { class: "nge-quest-daily-header" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-quest-daily-title" }, "Today's Quests", -1 /* HOISTED */))
const _hoisted_12 = { class: "nge-quest-daily-date" }
const _hoisted_13 = { class: "nge-quest-daily-pips" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 0,
  class: "nge-quest-daily-pip-check"
}
const _hoisted_16 = {
  key: 1,
  class: "nge-quest-daily-pip-num"
}
const _hoisted_17 = { class: "nge-quest-daily-pip-name" }
const _hoisted_18 = {
  key: 0,
  class: "nge-quest-celebration"
}
const _hoisted_19 = { class: "nge-quest-celebration-particles" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-quest-celebration-badge" }, "✦", -1 /* HOISTED */))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-quest-celebration-title" }, "Quest Complete!", -1 /* HOISTED */))
const _hoisted_22 = { class: "nge-quest-celebration-sub" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_24 = { class: "nge-quest-celebration-actions" }
const _hoisted_25 = { class: "nge-quest-progress" }
const _hoisted_26 = { class: "nge-quest-progress-track" }
const _hoisted_27 = { class: "nge-quest-progress-text" }
const _hoisted_28 = { class: "nge-quest-card-header" }
const _hoisted_29 = {
  key: 0,
  class: "nge-quest-badge nge-quest-badge--done"
}
const _hoisted_30 = {
  key: 1,
  class: "nge-quest-badge nge-quest-badge--active"
}
const _hoisted_31 = {
  key: 2,
  class: "nge-quest-badge nge-quest-badge--new"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-quest-seg-jump" }, "↗", -1 /* HOISTED */))
const _hoisted_33 = { class: "nge-quest-seg-row" }
const _hoisted_34 = { class: "nge-quest-seg-id-full" }
const _hoisted_35 = ["title"]
const _hoisted_36 = {
  key: 0,
  class: "nge-quest-notes"
}
const _hoisted_37 = {
  key: 1,
  class: "nge-quest-field"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "nge-quest-label",
  title: "Right-click on the nucleus in the viewer, then click the copy/paste icon at the top-left to copy coordinates"
}, [
  /*#__PURE__*/_createTextVNode(" Soma Coords "),
  /*#__PURE__*/_createElementVNode("span", { class: "nge-quest-req" }, "*"),
  /*#__PURE__*/_createElementVNode("span", { class: "nge-quest-label-hint" }, "ⓘ right-click nucleus → copy icon")
], -1 /* HOISTED */))
const _hoisted_39 = { class: "nge-quest-field-row" }
const _hoisted_40 = ["disabled"]
const _hoisted_41 = {
  key: 0,
  class: "nge-quest-field-error"
}
const _hoisted_42 = {
  key: 1,
  role: "alert",
  class: "nge-quest-field-error",
  style: {"font-size":"14px","line-height":"1.4"}
}
const _hoisted_43 = {
  key: 2,
  class: "nge-quest-field"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "nge-quest-label" }, [
  /*#__PURE__*/_createTextVNode("Final Seg ID "),
  /*#__PURE__*/_createElementVNode("span", { class: "nge-quest-req" }, "*")
], -1 /* HOISTED */))
const _hoisted_45 = {
  key: 3,
  class: "nge-quest-field"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "nge-quest-label" }, [
  /*#__PURE__*/_createTextVNode("Label "),
  /*#__PURE__*/_createElementVNode("span", { class: "nge-quest-opt" }, "(optional)")
], -1 /* HOISTED */))
const _hoisted_47 = {
  key: 4,
  class: "nge-quest-done-info"
}
const _hoisted_48 = { key: 0 }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-quest-done-lbl" }, "Soma", -1 /* HOISTED */))
const _hoisted_50 = { key: 1 }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-quest-done-lbl" }, "Final", -1 /* HOISTED */))
const _hoisted_52 = ["disabled"]
const _hoisted_53 = { class: "nge-quest-nav" }
const _hoisted_54 = { class: "nge-quest-footer" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, {
      name: "nge-quest",
      appear: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "nge-quest-board",
          style: _normalizeStyle($setup.panelStyle)
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["nge-quest-topbar", { 'nge-quest-dragging': $setup.isDragging }]),
            onMousedown: $setup.startDrag
          }, [
            _hoisted_1,
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("button", {
                class: "nge-quest-close",
                onClick: _cache[0] || (_cache[0] = $event => ($setup.emit('hide')))
              }, "×")
            ])
          ], 34 /* CLASS, HYDRATE_EVENTS */),
          _createCommentVNode(" Setup: paste sheet URL "),
          ($setup.showSetup)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _hoisted_4,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.sheetInput) = $event)),
                  class: "nge-quest-input nge-quest-url-input",
                  placeholder: "https://docs.google.com/spreadsheets/d/...",
                  onKeydown: [
                    _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
                    _withKeys($setup.loadSheet, ["enter"])
                  ],
                  onKeyup: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
                  onKeypress: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_5), [
                  [_vModelText, $setup.sheetInput]
                ]),
                _createElementVNode("button", {
                  class: "nge-quest-load-btn",
                  onClick: $setup.loadSheet,
                  disabled: !$setup.sheetInput.trim()
                }, " Load Quests ", 8 /* PROPS */, _hoisted_6),
                ($setup.queue.error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString($setup.queue.error), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ]))
            : ($setup.queue.loading)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createCommentVNode(" Loading state "),
                  _hoisted_8
                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createCommentVNode(" ═══════════════════════════════════════════════════════════\n             DAILY QUEST VIEW — 3 neurons per day + card detail\n             ═══════════════════════════════════════════════════════════ "),
                  _createElementVNode("div", _hoisted_9, [
                    _createCommentVNode(" Daily header "),
                    _createElementVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _createElementVNode("div", _hoisted_12, _toDisplayString($setup.todayLabel), 1 /* TEXT */)
                    ]),
                    _createCommentVNode(" Daily progress pips "),
                    _createElementVNode("div", _hoisted_13, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dailyQuests, (dq, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: dq.segId,
                          class: _normalizeClass(["nge-quest-daily-pip-card", {
                'nge-quest-daily-pip-card--done': $setup.queue.proofread.has(dq.segId),
                'nge-quest-daily-pip-card--active': $setup.current && $setup.current.segId === dq.segId,
              }]),
                          onClick: $event => ($setup.selectDailyQuest(i))
                        }, [
                          ($setup.queue.proofread.has(dq.segId))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, "✓"))
                            : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(i + 1), 1 /* TEXT */)),
                          _createElementVNode("span", _hoisted_17, _toDisplayString($setup.getNickname(dq.segId)), 1 /* TEXT */)
                        ], 10 /* CLASS, PROPS */, _hoisted_14))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _createCommentVNode(" Daily complete celebration "),
                    ($setup.dailyComplete && !$setup.celebrationDismissed)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (i) => {
                              return _createElementVNode("span", {
                                key: i,
                                class: "nge-quest-particle",
                                style: _normalizeStyle({ '--i': i })
                              }, null, 4 /* STYLE */)
                            }), 64 /* STABLE_FRAGMENT */))
                          ]),
                          _hoisted_20,
                          _hoisted_21,
                          _createElementVNode("div", _hoisted_22, [
                            _createTextVNode(" You finished all " + _toDisplayString($setup.dailyQuests.length) + " neurons for today. ", 1 /* TEXT */),
                            _hoisted_23,
                            _createTextVNode("The connectome thanks you! ")
                          ]),
                          _createElementVNode("div", _hoisted_24, [
                            ($setup.hasMoreUnproofread)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: "nge-quest-celebration-btn nge-quest-celebration-btn--more",
                                  onClick: $setup.takeOnMoreQuests
                                }, " 🧠 Take on Next Quest "))
                              : (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  class: "nge-quest-celebration-btn nge-quest-celebration-btn--more",
                                  onClick: _cache[5] || (_cache[5] = $event => {$setup.queue.resetAll(); $setup.resetGeneration++; $setup.bonusQuestIndices = []; $setup.celebrationDismissed = true}),
                                  title: "Reset and get fresh quests"
                                }, " ✨ New Quest! ")),
                            _createElementVNode("button", {
                              class: "nge-quest-celebration-btn nge-quest-celebration-btn--close",
                              onClick: _cache[6] || (_cache[6] = $event => ($setup.celebrationDismissed = true))
                            }, " Continue ")
                          ]),
                          _createElementVNode("button", {
                            class: "nge-quest-share-btn",
                            onClick: $setup.shareOnX
                          }, " Share on 𝕏 ")
                        ]))
                      : _createCommentVNode("v-if", true),
                    _createCommentVNode(" Overall progress "),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", {
                          class: "nge-quest-progress-fill",
                          style: _normalizeStyle({ width: $setup.progress + '%' })
                        }, null, 4 /* STYLE */)
                      ]),
                      _createElementVNode("div", _hoisted_27, _toDisplayString($setup.queue.proofreadCount()) + "/" + _toDisplayString($setup.queue.totalCount()) + " total · " + _toDisplayString($setup.dailyProgress) + "/" + _toDisplayString($setup.dailyQuests.length) + " today ", 1 /* TEXT */)
                    ]),
                    _createCommentVNode(" Current quest card "),
                    ($setup.current)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: _normalizeClass(["nge-quest-card", {
            'nge-quest-card--done': $setup.isProofread,
            'nge-quest-card--active': $setup.isClaimed && !$setup.isProofread,
          }])
                        }, [
                          _createElementVNode("div", _hoisted_28, [
                            ($setup.isProofread)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_29, "✓ done"))
                              : ($setup.isClaimed)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_30, "active"))
                                : (_openBlock(), _createElementBlock("span", _hoisted_31, "new"))
                          ]),
                          _createCommentVNode(" Nickname (big & fun) "),
                          _createElementVNode("div", {
                            class: "nge-quest-nickname",
                            onClick: _cache[7] || (_cache[7] = $event => ($setup.queue.navigateToCurrentItem())),
                            title: "Jump to segment"
                          }, [
                            _createTextVNode(_toDisplayString($setup.getNickname($setup.current.segId)) + " ", 1 /* TEXT */),
                            _hoisted_32
                          ]),
                          _createCommentVNode(" Full Segment ID below "),
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("div", _hoisted_34, _toDisplayString($setup.current.segId), 1 /* TEXT */),
                            _createElementVNode("button", {
                              class: "nge-quest-copy",
                              onClick: $setup.copySegId,
                              title: $setup.copied ? 'Copied!' : 'Copy ID'
                            }, _toDisplayString($setup.copied ? '✓' : '📋'), 9 /* TEXT, PROPS */, _hoisted_35)
                          ]),
                          _createCommentVNode(" Notes from spreadsheet "),
                          ($setup.current.notes)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString($setup.current.notes), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true),
                          _createCommentVNode(" STEP 1: Claim — Enter Soma Coords "),
                          (!$setup.isProofread)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                _hoisted_38,
                                _createElementVNode("div", _hoisted_39, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (($setup.somaInput) = $event)),
                                    class: _normalizeClass(["nge-quest-input", { 'nge-quest-input--error': $setup.somaInput.trim() && !$setup.somaValidation.valid }]),
                                    placeholder: "x, y, z",
                                    title: "Right-click on the nucleus in the viewer, then click the copy/paste icon at the top-left to copy coordinates",
                                    onKeydown: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"])),
                                    onKeyup: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"])),
                                    onKeypress: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"])),
                                    onBlur: _cache[12] || (_cache[12] = $event => ($setup.somaInput.trim() && $setup.somaValidation.valid && $setup.claimCell()))
                                  }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
                                    [_vModelText, $setup.somaInput]
                                  ]),
                                  (!$setup.isClaimed)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: "nge-quest-btn-claim",
                                        onClick: $setup.claimCell,
                                        disabled: !$setup.somaInput.trim() || !$setup.somaValidation.valid
                                      }, "Claim", 8 /* PROPS */, _hoisted_40))
                                    : (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        class: "nge-quest-btn-jump",
                                        onClick: _cache[13] || (_cache[13] = $event => ($setup.queue.navigateToCurrentItem()))
                                      }, "Jump"))
                                ]),
                                ($setup.somaInput.trim() && !$setup.somaValidation.valid && $setup.somaValidation.error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString($setup.somaValidation.error), 1 /* TEXT */))
                                  : _createCommentVNode("v-if", true),
                                ($setup.sheetSyncError)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString($setup.sheetSyncError), 1 /* TEXT */))
                                  : _createCommentVNode("v-if", true)
                              ]))
                            : _createCommentVNode("v-if", true),
                          _createCommentVNode(" STEP 2: Final Seg ID "),
                          ($setup.isClaimed && !$setup.isProofread)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                _hoisted_44,
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => (($setup.finalSegInput) = $event)),
                                  class: "nge-quest-input",
                                  placeholder: "Final segment ID",
                                  onKeydown: _cache[15] || (_cache[15] = _withModifiers(() => {}, ["stop"])),
                                  onKeyup: _cache[16] || (_cache[16] = _withModifiers(() => {}, ["stop"])),
                                  onKeypress: _cache[17] || (_cache[17] = _withModifiers(() => {}, ["stop"])),
                                  onBlur: _cache[18] || (_cache[18] = $event => ($setup.finalSegInput.trim() && $setup.saveFinalSegId()))
                                }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                                  [_vModelText, $setup.finalSegInput]
                                ])
                              ]))
                            : _createCommentVNode("v-if", true),
                          _createCommentVNode(" STEP 3: Annotation (optional) "),
                          ($setup.isClaimed && !$setup.isProofread)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                _hoisted_46,
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => (($setup.annotationInput) = $event)),
                                  class: "nge-quest-input",
                                  placeholder: "SAC, Muller, Glia…",
                                  onKeydown: _cache[20] || (_cache[20] = _withModifiers(() => {}, ["stop"])),
                                  onKeyup: _cache[21] || (_cache[21] = _withModifiers(() => {}, ["stop"])),
                                  onKeypress: _cache[22] || (_cache[22] = _withModifiers(() => {}, ["stop"])),
                                  onBlur: _cache[23] || (_cache[23] = $event => ($setup.annotationInput.trim() && $setup.saveAnnotation()))
                                }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                                  [_vModelText, $setup.annotationInput]
                                ])
                              ]))
                            : _createCommentVNode("v-if", true),
                          _createCommentVNode(" Completed summary "),
                          ($setup.isProofread)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                ($setup.somaInput)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                      _hoisted_49,
                                      _createTextVNode(" " + _toDisplayString($setup.somaInput), 1 /* TEXT */)
                                    ]))
                                  : _createCommentVNode("v-if", true),
                                ($setup.finalSegInput)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                      _hoisted_51,
                                      _createTextVNode(" " + _toDisplayString($setup.finalSegInput), 1 /* TEXT */)
                                    ]))
                                  : _createCommentVNode("v-if", true)
                              ]))
                            : _createCommentVNode("v-if", true)
                        ], 2 /* CLASS */))
                      : _createCommentVNode("v-if", true),
                    _createCommentVNode(" Mark complete button "),
                    ($setup.current && $setup.isClaimed && !$setup.isProofread)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          class: _normalizeClass(["nge-quest-complete", { 'nge-quest-complete--ready': $setup.canComplete }]),
                          disabled: !$setup.canComplete,
                          onClick: $setup.markProofreadAndNext
                        }, " ✓ Complete Quest ", 10 /* CLASS, PROPS */, _hoisted_52))
                      : _createCommentVNode("v-if", true),
                    _createCommentVNode(" Navigation "),
                    _createElementVNode("div", _hoisted_53, [
                      _createElementVNode("button", {
                        class: "nge-quest-nav-btn",
                        onClick: $setup.goPrev
                      }, "◀"),
                      _createElementVNode("button", {
                        class: "nge-quest-nav-btn",
                        onClick: $setup.goNext
                      }, "▶"),
                      _createElementVNode("button", {
                        class: "nge-quest-nav-btn nge-quest-nav-btn--skip",
                        onClick: _cache[24] || (_cache[24] = $event => ($setup.queue.nextUnproofread()))
                      }, "Skip ▶▶")
                    ]),
                    _createCommentVNode(" Footer "),
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("button", {
                        class: "nge-quest-footer-btn",
                        onClick: _cache[25] || (_cache[25] = $event => ($setup.queue.loadFromSheet()))
                      }, "↻ Reload"),
                      _createElementVNode("button", {
                        class: "nge-quest-footer-btn",
                        onClick: _cache[26] || (_cache[26] = $event => {$setup.queue.resetAll(); $setup.resetGeneration++; $setup.bonusQuestIndices = []})
                      }, "Reset")
                    ])
                  ])
                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
        ], 4 /* STYLE */)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}